import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { classNames as cn } from '../utils';
export function Transition({ show, children, enter = 'transition-all duration-300 ease-out', enterFrom = 'opacity-0', enterTo = 'opacity-100', leave = 'transition-all duration-300 ease-in', leaveFrom = 'opacity-100', leaveTo = 'opacity-0', afterLeave, afterEnter, className, as: Component = 'div', }) {
    const [shouldRender, setShouldRender] = useState(show);
    const [stage, setStage] = useState(show ? 'entered' : 'left');
    const initialRender = useRef(true);
    useEffect(() => {
        if (initialRender.current) {
            initialRender.current = false;
            if (show) {
                setShouldRender(true);
                setStage('entered');
            }
            return;
        }
        if (show) {
            setShouldRender(true);
            // Start with enterFrom classes, then switch to enterTo on next frame
            setStage('entering');
            const frame = requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    setStage('entered');
                });
            });
            return () => cancelAnimationFrame(frame);
        }
        else {
            // Start with leaveFrom, then switch to leaving on next frame
            setStage('leaveStart');
            const frame = requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    setStage('leaving');
                });
            });
            return () => cancelAnimationFrame(frame);
        }
    }, [show]);
    const handleTransitionEnd = (e) => {
        // Only handle transitions on the root element, not children
        if (e.target !== e.currentTarget)
            return;
        if (stage === 'leaving') {
            setShouldRender(false);
            setStage('left');
            afterLeave === null || afterLeave === void 0 ? void 0 : afterLeave();
        }
        else if (stage === 'entered') {
            afterEnter === null || afterEnter === void 0 ? void 0 : afterEnter();
        }
    };
    if (!shouldRender)
        return null;
    const transitionClasses = cn(className, stage === 'entering' && [enter, enterFrom], stage === 'entered' && [enter, enterTo], stage === 'leaveStart' && [leave, leaveFrom], stage === 'leaving' && [leave, leaveTo]);
    return (_jsx(Component, { className: transitionClasses, onTransitionEnd: handleTransitionEnd, children: children }));
}
